import { render } from "./NewsList.vue?vue&type=template&id=6f5527f8&scoped=true"
import script from "./NewsList.vue?vue&type=script&lang=js"
export * from "./NewsList.vue?vue&type=script&lang=js"

import "./NewsList.vue?vue&type=style&index=0&id=6f5527f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5527f8"]])

export default __exports__